<div class="settingsBody">
    <div class="settings-heading">Product Mapping</div>
    <div class="client-product-mapping-control-area">
        <div class="client-product-mapping-search-excel-area">
            <div class="client-product-mapping-search-area">
                <search-dialog
                    (searchOutput)="searchRows($event)"
                    [searchId]="'client-product-mapping-search'"
                    [searchBoxHeight]="44"
                    [resetSearch]="false"
                >
                </search-dialog>
            </div>
            <div class="mapping-export-button-area">
                <span
                    (click)="exportToExcel()"
                    title="Download Excel"
                    class="mapping-export-button"
                >
                    <mat-icon fontSet="fas" fontIcon="fa-file-excel"></mat-icon>
                </span>
            </div>
        </div>
        <div class="client-product-mapping-save-button-area">
            <button
                mat-raised-button
                class="button"
                [disabled]="saveBtnDisabled"
                (click)="submitChanges()"
            >
                SAVE CHANGES
            </button>
        </div>
    </div>
    <div>
        <custom-mat-table
            [customTableInfo]="customTableInfo"
            (contentChanged)="contentChanged($event)"
            (inputChangeEvent)="dropdownSelectEvent($event)"
        ></custom-mat-table>
    </div>
</div>
